import React, { ReactNode } from "react";
import usePermissioned from "../../hooks/usePermissioned";
import { operationType, resourceType } from "../../interfaces/roles";

type propTypes = {
  operation: operationType;
  children: ReactNode;
  resource: resourceType;
};
const PermissionAction = ({
  operation,
  children,
  resource,
}: propTypes) => {
  const { isPermissioned } = usePermissioned(operation, resource);
  
  if (!isPermissioned ) {
    return null;
  }

  return <>{children}</>;
};

export default PermissionAction;
